import { injectable, interfaces } from 'inversify';

type CallBackFunction = () => boolean;

export interface IBrowserService {
  addOnBeforeUnload(func: CallBackFunction): void;
  clearCallBacks(): void;
}

export namespace IBrowserService {
  export const $: interfaces.ServiceIdentifier<IBrowserService> = Symbol('BROWSER_SERVICE');
}

@injectable()
export class BrowserService implements IBrowserService {
  onBeforeUnloadCallBacks: CallBackFunction[] = [];

  constructor() {
    window.onbeforeunload = (): string | undefined => {
      if (this.onBeforeUnloadCallBacks.some((n) => n())) {
        return '';
      }
      return undefined;
    };
  }

  addOnBeforeUnload(func: CallBackFunction): void {
    this.onBeforeUnloadCallBacks.push(func);
  }

  clearCallBacks(): void {
    this.onBeforeUnloadCallBacks = [];
  }
}
